import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

type LoaderState = {
  isLoading: {
    status: boolean
    from: string
    message: string
  }
}

type LoaderActions = {
  setIsLoading: (status: boolean, from: string, message: string) => void
  startLoading: (from: string, message?: string) => () => void
}

export const useLoaderStore = create<LoaderState & LoaderActions>()(
  devtools(
    (set) => {
      const pending = new Map<
        string | symbol,
        { from: string; message: string }
      >()
      const publish = () => {
        const active = Array.from(pending.values()).at(-1)
        set({
          isLoading: active
            ? { status: true, ...active }
            : { status: false, from: '', message: '' },
        })
      }

      return {
        isLoading: { status: false, from: '', message: '' },
        setIsLoading: (status, from, message) => {
          if (status) {
            pending.delete(from)
            pending.set(from, { from, message })
          } else if (from) {
            pending.delete(from)
          } else {
            pending.clear()
          }
          publish()
        },
        startLoading: (from, message = '') => {
          const id = Symbol(from)
          pending.set(id, { from, message })
          publish()
          return () => {
            if (pending.delete(id)) publish()
          }
        },
      }
    },
    { name: 'loader-store' }
  )
)
